export const getIsAnonymized = (state) =>
  state.anonymizer?.get('anonymizeProfiles');
